// import request from "@/utils/request";
// import upload from '@/utils/upload'
import request from "@/utils/cdRequest";
import yRrequest from "@/utils/request";
import gjtRequest from "@/utils/gjtRequest";

/*
 * 川大通用列表查询接口
 */
export function getNewsList(data) {
  return request({
    url: "/interface/getNewsList.do",
    method: "post",
    data,
  });
}

/*
 * 川大通用详情查询接口
 */
export function getNewsContent(data) {
  return request({
    url: "/interface/getNewsContent.do",
    method: "post",
    data,
  });
}

/*
 * 老师登录接口
 */
export function teacherLoginCheck(data) {
  return yRrequest({
    url: "/login/teacherLoginCheck",
    method: "post",
    data,
  });
}

/*
 * 学生登录接口
 */
export function studentLoginCheck(data) {
  return yRrequest({
    url: "/login/studentLoginCheck",
    method: "post",
    data,
  });
}

/*
 * 高教通登录学生登录接口
 */
export function ticketStuLogin(data) {
  return gjtRequest({
    url: "/login/ticketStuLogin.action",
    method: "post",
    data,
  });
}

/*
 * 高教通登录老师登录接口
 */
export function ticketTeaLogin(data) {
  return gjtRequest({
    url: "/login/teacherLogin.action",
    method: "post",
    data,
  });
}


/*
 * 系统列表-通知公告接口
 */
export function queryNewsList() {
  return yRrequest({
    url: "/news/queryNewsList",
    method: "get"
  });
}

/*
 * 获取系统名称-接口
 */
export function systemInfo() {
  return yRrequest({
    url: "/base/systemInfo",
    method: "get"
  });
}

// /*
//  * 报名查询
//  */
// export function joinQuery(data) {
//     return request({
//         url: "/stu/getRegZyList",
//         method: "post",
//         data,
//     });
// }


// /*
//  * 缴费查询
//  */
// export function payQuery(data) {
//     return request({
//         url: '/stu/getPreStuInfo',
//         method: "post",
//         data,
//     });
// }


/* 
 * 生成缴费订单
 */
// export function generateOrder(data) {
//     return upload({
//       url: '/stu/generateOrder',
//       method: 'post',
//       data,
//     })
//   }